import { gql, TypedDocumentNode } from '@apollo/client'

import { AuditLogDTO } from 'features/history/types/auditLogDTO'

export const AUDIT_LOG_FRAGMENT: TypedDocumentNode<AuditLogDTO> = gql`
  fragment AuditLogFragment on AuditLog {
    logEntry
  }
`
